export default __webpack_public_path__ + "static/media/operator.8d686da0.svg";